// extracted by mini-css-extract-plugin
export default {"conteiner":"Introduction_conteiner__Mkg5p","infsConteiner":"Introduction_infsConteiner__7YKH0"};